import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import './Login.css';

function Login() {
  const [isLogin, setIsLogin] = useState(true);
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showAbout, setShowAbout] = useState(false);
  
  const { login, register } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    let result;
    if (isLogin) {
      result = await login(username, password);
    } else {
      if (!email) {
        setError('Email is required');
        setLoading(false);
        return;
      }
      result = await register(username, email, password);
    }

    if (!result.success) {
      setError(result.error);
    }
    
    setLoading(false);
  };

  if (showAbout) {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <h1>About Documind</h1>
            <p>AI-Powered Document Intelligence</p>
          </div>

          <div style={{ 
            color: 'rgba(255, 255, 255, 0.85)', 
            lineHeight: '1.8',
            fontSize: '0.95rem'
          }}>
            <div style={{ marginBottom: '1.5rem' }}>
              <h3 style={{ color: '#10a37f', marginBottom: '0.5rem' }}>Developer</h3>
              <p><strong>Muhammad Saad Khan</strong></p>
              <p style={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                Graduate from University of Swabi
              </p>
            </div>

            <div style={{ marginBottom: '1.5rem' }}>
              <h3 style={{ color: '#10a37f', marginBottom: '0.5rem' }}>Expertise</h3>
              <p>🤖 AI Application Development</p>
              <p>🔧 Applied AI Engineering</p>
              <p>🐍 Python Programming (Advanced)</p>
              <p>📊 Data Analysis & Visualization</p>
              <p>📈 NumPy & Pandas Expert</p>
              <p>✨ Feature Engineering & ML</p>
            </div>

            <div style={{ marginBottom: '1.5rem' }}>
              <h3 style={{ color: '#10a37f', marginBottom: '0.5rem' }}>About Documind</h3>
              <p>
                An intelligent document assistant powered by advanced RAG (Retrieval-Augmented Generation) 
                technology. Upload your PDFs and have natural conversations with your documents using AI.
              </p>
            </div>

            <div>
              <h3 style={{ color: '#10a37f', marginBottom: '0.5rem' }}>Future Vision</h3>
              <p>
                Passionate about advancing AI/ML technologies and building innovative applications 
                that make AI accessible and useful for everyone.
              </p>
            </div>
          </div>

          <button
            onClick={() => setShowAbout(false)}
            className="submit-btn"
            style={{ marginTop: '1.5rem' }}
          >
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>🤖 Documind</h1>
          <p>AI Document Assistant</p>
        </div>

        <div className="toggle-container">
          <button
            className={`toggle-btn ${isLogin ? 'active' : ''}`}
            onClick={() => {
              setIsLogin(true);
              setError('');
            }}
          >
            Login
          </button>
          <button
            className={`toggle-btn ${!isLogin ? 'active' : ''}`}
            onClick={() => {
              setIsLogin(false);
              setError('');
            }}
          >
            Register
          </button>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              minLength={3}
              placeholder="Enter your username"
              autoComplete="username"
            />
          </div>

          {!isLogin && (
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="Enter your email"
                autoComplete="email"
              />
            </div>
          )}

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
              placeholder="Minimum 6 characters"
              autoComplete={isLogin ? "current-password" : "new-password"}
            />
          </div>

          {error && (
            <div className="error-message">
              ⚠️ {error}
            </div>
          )}

          <button 
            type="submit" 
            className={`submit-btn ${loading ? 'loading' : ''}`}
            disabled={loading}
          >
            {loading ? '' : (isLogin ? 'Login' : 'Register')}
          </button>
        </form>

        <div className="login-footer">
          <p>🔒 Secure authentication • 📄 PDF analysis • 🤖 AI-powered</p>
          
          <div className="developer-info">
            <p>
              Developed by <strong>Muhammad Saad Khan</strong>
            </p>
            <button
              type="button"
              onClick={() => setShowAbout(true)}
              className="about-link"
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: 0
              }}
            >
              Learn more about the developer →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
